export enum SortingKeysEnum {
    lastName="lastName",
    role="role",
   
    country="country",
    clinicId="clinicId",
   
}
